import dayjs from "dayjs";
import { cloneDeep } from "lodash";

import { filterDateByRange } from "@/utils/filterDateByRange";

import type { DatesRange } from "@/types/entity";
import type { Performance, PerformanceChart, PortfolioPayload } from "@/types/performance";

export function mapPayloadToPortfolioPerfomance(
  data: PortfolioPayload,
  perfomanceName = "average",
  hideLastMonth = true
) {
  const currentMonth = hideLastMonth ? dayjs().format("YYYY-MM") : false;
  const benchmarks: PerformanceChart[] = [];
  const performance: PerformanceChart = {
    name: perfomanceName,
    data: [],
  };
  data.forEach((item) => {
    // The last month is incomplete, so we skip it
    if (item.month !== currentMonth) {
      performance.data.push({ date: item.month, value: item.value });
    }
  });

  return {
    benchmarks,
    performance,
  } as Performance;
}

export function getDataFilteredByRange(response: Performance, range?: DatesRange) {
  let data = cloneDeep(response!);

  if (range) {
    const filterDate = filterDateByRange(range);

    data.performance.data = data.performance.data.filter(filterDate);

    if (data.benchmarks) {
      data.benchmarks = data.benchmarks.map((benchmark) => ({
        ...benchmark,
        data: benchmark.data.filter(filterDate),
      }));
    }
  }

  return data;
}
